// Phase-3 storefront search, shared by the shop grid and the home grid.
// Ported from Red Robin (commit 4eb4d9e) and lifted into its own module so both of
// Glen's search boxes behave identically.
//
// Name-only search is thin once a catalogue has categories: a shopper typing
// "ukulele" expects a hit whether that word is the name or the category. Every term
// must match somewhere (AND, not OR), so "lowden acoustic" narrows rather than
// returning every Lowden plus every acoustic. Accents are folded, so typing
// "bodhran" finds "Bodhran" and "Bodhrán" alike.
//
// `collections` is read defensively: Glen's catalogue has no such field today, so it
// contributes nothing. The day it gains one, brand search starts working with no edit.
// Descriptions are deliberately NOT searched - his are raw HTML, so tag names would
// match. That needs plain_text stripping first.

export const fold = (s: string) =>
    (s || '').toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '');
  
  export interface Searchable {
    name?: string;
    category?: string;
    collections?: string[];
  }
  
  export function matchesSearch(p: Searchable, query: string): boolean {
    const terms = fold(query).split(/\s+/).filter(Boolean);
    if (!terms.length) return true;
    const haystack = fold([
      p.name,
      p.category,
      ...((p as any).collections || []),
    ].filter(Boolean).join(' '));
    return terms.every((t) => haystack.includes(t));
  }